exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.switch {\n    border-width: 0.02667rem;\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-switch/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,yBAAkB;CACnB;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .switch {\n    border-width: 2px;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76af8caf","scoped":false,"hasInlineConfig":false}!./packages/dof-switch/colmo.css
// module id = 227
// module chunks = 0 1